module.exports = __webpack_public_path__ + "static/media/threeinthree.d4ab85d2.jpg";